/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import moment from 'moment';

import PopOverMenu from '../../PopOverMenu';
import SportLabel from '../CardComponents/SportLabel';
import { getFlagUrl, getPlayerName, wonGame, wonSet, playerTypes, getRatingDetails, setRatingChoice } from '../../../utils';
import Popup from '../../Popup';
import BackgroundImage from '../../BackgroundImage';
import Img from '../../Img';
import PhoneInfoPopup from '../../PopUps/PhoneInfoPopup';
import Utr from '../../text/Utr';
import withAuth from '../../hocs/withAuth';
import * as postScoreActions from '../../../actions/post-score-actions';
import { titleCase, formatMatchDateWithOffset, formatMatchTime } from '../../../utils/formatting';
import { shouldDisplayRoundNumbers } from '../../../utils/events';
import { renderHSInfo } from '../../../utils/draws';
import { ratingTypes, ScoreUpdateRequestTypes, DataImportTypeIds } from '../../../utils/constants';
import { ForfeitValues, OutComeTypes, AbandonedMatchLabel, DoubleWalkoverLabel, DefaultedLabel, WithdrewLabel } from '../../../utils/postScoreConstants';
import config from '../../../../config';
import { getApiAxiosInstance } from '../../../utils/network';
import { submitScoreUpdateRequest } from '../../../api';
import { isPendingMatch, showMatchWinner } from '../../../utils/postScore';

import styles from './scorecard.scss';

const _ = { cloneDeep };

class ScoreCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showDeletePopUp: false,
            showConfirmPopUp: false,
            showProtestPopUp: false,
            showIncorrectScorePopUp: false,
            showScoreUpdateSuccessPopUp: false,
            sourceUrl: '',
            sourceUrlError: '',
            isSubmitting: false,
        };
        this.onSelected = this.onSelected.bind(this);
    }

    onSelected(menuOption, ev) {
        const clubProfilePage = this.props.match.path === '/:clubType(clubs|schools|colleges)/:clubId';
        const { isFlexLeagueEventPlayerPostDraw, tmsEventDrawMatchId } = this.props;
        switch (menuOption.id) {
            case 'edit_score':
                this.props.setPlayerPostedMatch({
                    result: this.props,
                });
                if (clubProfilePage) {
                    const { clubId } = this.props.match.params;
                    this.props.history.push(`/clubs/${clubId}/post-score`);
                } else if (isFlexLeagueEventPlayerPostDraw) {
                    let searchString = `matchId=${tmsEventDrawMatchId}&flexLeagues=true`;
                    if (this.props.redirectUrl) {
                        searchString = searchString.concat(`&redirectUrl=${this.props.redirectUrl}`);
                    }
                    this.props.history.push({ pathname: `/player/post-score`, search: searchString });
                    this.props.setRound({ redirectUrlPage: 'FlexLeagues' });
                } else {
                    this.props.history.push(`/post-score-select`);
                    this.props.setRound({ redirectUrlPage: 'selfPost' });
                }
                break;
            case 'delete_score':
                this.setState({
                    showDeletePopUp: true,
                });
                break;
            case 'accept_score':
                if (isFlexLeagueEventPlayerPostDraw) {
                    this.setState({
                        showConfirmPopUp: true,
                    });
                } else {
                    this.props.acceptOrRejectScore(this.props.id, 'accept', this.props);
                }
                break;
            case 'reject_score':
                this.props.acceptOrRejectScore(this.props.id, 'reject', this.props);
                break;
            case 'protest':
                this.setState({
                    showProtestPopUp: true,
                });
                break;
            case 'incorrect_score':
                this.setState({
                    showIncorrectScorePopUp: true,
                });
                break;
            default:
                this.props.onSelected(menuOption, ev);
                break;
        }
    }

    getIncorrectScoreMessage() {
        const dataImportTypeId = this.props.batchDataImportType;

        if (dataImportTypeId === DataImportTypeIds.USTA_TOURNAMENTS) {
            return {
                header: 'Action Needed: Score Update',
                details: 'Please have the tournament director update the score on the USTA site first. Our system should sync approximately 24 hours after that update. If the score still doesn\'t update on our site after that time, please share the URL where the correct score is displayed.',
            };
        }

        if (dataImportTypeId === DataImportTypeIds.USTA_LEAGUES) {
            return {
                header: 'Action Needed: Score Update',
                details: 'Please have the team captain update the score on the USTA site first. Our system should sync approximately 24 hours after that update. If the score still doesn\'t update on our site after that time, please share the URL where the correct score is displayed.',
            };
        }

        return {
            header: 'We need more information',
            details: 'Please share the URL with the correct score, and we\'ll update it within 48 hours.',
        };
    }

    getScoresText(scores) {
        const scoresDisplay = [];
        const scoreArray = Object.values(scores);
        if (scoreArray.length > 0) {
            scoreArray.forEach((scoreItem) => {
                scoresDisplay.push(`${scoreItem.winner}-${scoreItem.loser}`);
            });
        }

        return scoresDisplay.join(', ');
    }

    getMatchText(players, scores, isConfirmPopup) {
        let string = '';
        string += getPlayerName(players.winner1.firstName, players.winner1.lastName, true);
        if (players.winner2) {
            string = `${string}/${getPlayerName(players.winner2.firstName, players.winner2.lastName, true)}`;
        }
        string += isConfirmPopup ? ' def. ' : ' vs ';
        string += getPlayerName(players.loser1.firstName, players.loser1.lastName, true);
        if (players.loser2) {
            string = `${string}/${getPlayerName(players.loser2.firstName, players.loser2.lastName, true)}`;
        }

        if (isConfirmPopup) {
            string = `${string} ${this.getScoresText(scores)}`;
        }

        return string;
    }

    getCurrentStatus() {
        return this.props.scoreUpdateRequestStatus || null;
    }

    validateUrl = (url) => {
        if (!url?.trim()) {
            return 'URL is required';
        }

        const trimmedUrl = url.trim();
        if (!trimmedUrl.match(/^https?:\/\//)) {
            return 'URL must start with http:// or https://';
        }

        const urlPattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/;
        if (!urlPattern.test(trimmedUrl)) {
            return 'Please enter a valid URL';
        }

        return '';
    };

    isSubmitDisabled = () => {
        if (this.shouldShowSourceUrlInput()) {
            const url = this.state.sourceUrl;
            return !url?.trim() || !!this.state.sourceUrlError;
        }
        return false;
    };

    isImportedResult() {
        return this.props.batchImportedResult === true;
    }

    shouldShowSourceUrlInput() {
        return this.props.batchDataImportType != null;
    }

    async submitScoreUpdateRequest(requestType, sourceUrl = null) {
        try {
            const axiosInstance = getApiAxiosInstance();
            const requestData = {
                resultId: this.props.id,
                requestType,
            };

            if (sourceUrl) {
                requestData.sourceUrl = sourceUrl;
            }

            await submitScoreUpdateRequest(axiosInstance, requestData);

            this.setState({
                showIncorrectScorePopUp: false,
                showScoreUpdateSuccessPopUp: true,
                sourceUrl: '',
                sourceUrlError: '',
                isSubmitting: false,
            });

            if (this.props.onScoreUpdateRequest) {
                this.props.onScoreUpdateRequest(this.props.id, 'Pending');
            }
        } catch (e) {
            console.error('Error submitting score update request:', e);
            this.setState({ isSubmitting: false });
        }
    }

    checkIfUserInMatch(auth, players) {
        if (auth && auth.user && auth.user.claimedPlayer && players) {
            const playersList = ['loser1', 'loser2', 'winner1', 'winner2'];
            let boolean = false;
            playersList.forEach((player) => {
                if (players[player] && players[player].id && parseInt(players[player].id) === auth.user.claimedPlayer.playerId) {
                    boolean = true;
                }
            });
            return boolean;
        }
        return false;
    }

    render() {
        const {
            players,
            position1,
            position2,
            playersDict,
            teamsDict,
            score,
            round,
            sourceType,
            forceCardView,
            force,
            playerId,
            gameType,
            id,
            eligibleResults,
            completionType,
            outcome,
            date,
            isEventScore,
            roundNumber,
            roundSize,
            matchPosition,
            position1Seed,
            position2Seed,
            detail,
            ballType,
            eliminationType,
            playerPostedResult,
            finalized,
            auth,
            showDecimals,
            utrType,
            clubIds,
            showDecimalForOwn,
            customDateString,
            isProProfile,
            ratingsNoShow,
            isRejected,
            actions,
            showDate,
            showOfficial,
            matchId,
            // showLocation,
            events,
            displayTime,
            currentEvent,
            isOfficialHSEvent,
            contacts,
            showContacts,
            isProfileResults,
            isLeaguesMatch,
            loser,
            winner,
            isProfileOverviewResult,
            eventName,
            eventId,
            sportTypeId,
            teamType,
            draw,
            'data-testid': dataTestId,
        } = this.props;

        const event = events?.currentEvent?.data;
        const scheduleType = event?.scheduleType?.value || 'matchsheet';
        const { matchSheet, orderOfPlay } = events?.currentEvent || {};

        const isProgressionDraw = ballType !== null;

        const clubProfilePage = this.props.match.path === '/:clubType(clubs|schools|colleges)/:clubId';

        const checkIfPlayerInResult = (playerId, players) => {
            const playerIdList = [];
            playerIdList.push(parseInt(players.winner1.id));
            playerIdList.push(parseInt(players.loser1.id));
            if (players.winner2) {
                playerIdList.push(parseInt(players.winner2.id));
            }
            if (players.loser2) {
                playerIdList.push(parseInt(players.loser2.id));
            }
            return playerIdList.indexOf(parseInt(playerId)) !== -1;
        };
        const lookUpPlayerId = playerId && checkIfPlayerInResult(playerId, players) ? playerId : players.winner1.id;
        const userLoggedIn = auth && auth.user;
        const showRatings = (userLoggedIn || isProProfile) && !ratingsNoShow;

        const walkOverValues = ['Walkover', 'Defaulted', 'Withdrew', 'Double Default', 'Abandoned', 'Abandoned Match', 'Double Walkover', 'walkover', 'defaulted', 'withdrew', 'double default', 'abandoned', 'abandoned match', 'double walkover'];
        const retiredValues = ['Retired', 'Injury', 'retired', 'injury'];
        let locationDisplay = detail;

        const leagueCompletionTypes = {
            WITHDREW: 'Player or Team Withdrew',
            DEFAULTED: 'Player or Team Defaulted',
            RETIRED: 'Player Retired',
            POSTPONED: 'Mark as Postponed',
        };

        let infoObj;
        let locationName;
        let facilityName;
        let courtName;
        if (scheduleType === 'matchsheet' && matchSheet && matchSheet.length) {
            const matchSheetIndex = matchSheet.findIndex(m => m.matchId === matchId);
            if (matchSheetIndex > -1) {
                infoObj = matchSheet[matchSheetIndex];
            }
        }
        if (scheduleType === 'orderofplay' && orderOfPlay && orderOfPlay.length) {
            const oopIndex = orderOfPlay.findIndex(m => m.matchId === matchId);
            if (oopIndex > -1) {
                infoObj = orderOfPlay[oopIndex];
            }
        }
        if (infoObj) {
            locationDisplay = null;
            if (infoObj.locationId || infoObj.facilityId || infoObj.courtId) {
                (events.currentEvent.locations || []).forEach(loc => {
                    if (loc.id === infoObj.locationId) {
                        locationName = loc.name;
                        loc.facilities.forEach(fac => {
                            if (fac.id === infoObj.facilityId) {
                                facilityName = fac.abbreviation || fac.name;
                                fac.courts.forEach(c => {
                                    if (c.id === infoObj.courtId) {
                                        courtName = c.name;
                                    }
                                });
                            }
                        });
                    }
                });
                if (!locationName) {
                    locationDisplay = 'Loading...';
                } else {
                    locationDisplay = [facilityName, courtName].filter(Boolean).join(', ');
                }
            }
        }
        const hasScore = !!Object.values(score || {}).length;

        const menuOptions = this.props.menuOptions ? this.props.menuOptions : [];
        if (actions?.edit?.allowed && (!clubIds || (clubIds.length === 0) || clubProfilePage)) {
            menuOptions.push({
                id: 'edit_score',
                label: 'Edit Score',
                value: 'edit_score',
            });
        }
        if (actions?.delete?.allowed && (!clubIds || (clubIds.length === 0) || clubProfilePage)) {
            menuOptions.push({
                id: 'delete_score',
                label: 'Delete Score',
                value: 'delete_score',
            });
        }
        if (actions?.protest?.allowed) {
            menuOptions.push({
                id: 'protest',
                label: 'Protest',
                value: 'protest',
            });
        }

        const isImportedResult = this.isImportedResult();

        if (isImportedResult) {
            menuOptions.push({
                id: 'incorrect_score',
                label: 'Incorrect Score',
                value: 'incorrect_score',
            });
        }

        const desktopMenuOptions = _.cloneDeep(menuOptions);
        const { isFlexLeagueEventPlayerPostDraw } = this.props;
        const showAcceptOrReject = (actions?.accept?.allowed || actions?.reject?.allowed) && !isFlexLeagueEventPlayerPostDraw;
        if (actions?.reject?.allowed) {
            desktopMenuOptions.splice(0, 0, {
                id: 'reject_score',
                label: 'Deny',
                value: 'Deny',
            });
        }
        if (actions?.accept?.allowed) {
            desktopMenuOptions.splice(0, 0, {
                id: 'accept_score',
                label: 'Confirm',
                value: 'Confirm',
            });

            if (isFlexLeagueEventPlayerPostDraw) {
                menuOptions.splice(0, 0, {
                    id: 'accept_score',
                    label: 'Confirm',
                    value: 'Confirm',
                });
            }
        }

        const getTeamTypeString = () => {
            const typesObject = {
                s: 'Singles',
                d: 'Doubles',
                g: 'Dingles',
            };

            return typesObject[teamType?.toLowerCase()];
        };

        const renderNonEventRoundLabel = () => {
            let roundLabel = '';

            if (playerPostedResult) {
                roundLabel = 'Individual Match';
            } else if (clubIds && clubIds.length > 0) {
                roundLabel = 'Club Match';
            } else if (isLeaguesMatch) {
                roundLabel = 'Leagues';
            } else {
                roundLabel = round?.name;
            }

            if (teamType) {
                if (roundLabel?.length > 0) {
                    roundLabel = `${roundLabel} • ${getTeamTypeString()}`;
                } else {
                    roundLabel = getTeamTypeString();
                }
            }

            return roundLabel;
        };

        const renderRoundLabel = () => {
            let roundLabel = '';
            const isShowingNumbers = shouldDisplayRoundNumbers(eliminationType);
            if (isShowingNumbers) {
                roundLabel = `R${roundNumber}`;
            } else if (eliminationType && eliminationType === 'match_play') {
                roundLabel = `Match ${matchPosition}`;
            } else if (roundSize === 1) {
                roundLabel = `F`;
            } else if (roundSize === 2) {
                roundLabel = `SF • Match ${matchPosition}`;
            } else if (roundSize === 4) {
                roundLabel = `QF • Match ${matchPosition}`;
            } else {
                roundLabel = `R${roundSize * 2} • Match ${matchPosition}`;
            }

            if (teamType) {
                roundLabel = `${roundLabel} • ${getTeamTypeString()}`;
            }

            return <span data-testid={dataTestId && `${dataTestId}.mobile.round-number`}>{roundLabel}</span>;
        };

        const getRatingTitle = (player, gameType) => {
            const rating = getRatingDetails(setRatingChoice({ player, ratingType: gameType, utrType }));
            return rating.utrType;
        };

        const getLeaguesMatchOutcome = (completionType) => {
            const { WITHDREW, DEFAULTED } = leagueCompletionTypes;
            if (completionType === DEFAULTED) {
                return 'Defaulted';
            }

            if (completionType === WITHDREW) {
                return 'Withdrew';
            }

            if (completionType === WITHDREW) {
                return 'Withdrew';
            }

            return '';
        };

        // eslint-disable-next-line consistent-return
        const getScores = (scores, playerType, testIdPrefix = null) => {
            if (scores && playerType) {
                const scoreArray = Object.values(scores);
                if (scoreArray.length > 0) {
                    return (
                        <>
                            {scoreArray.map((scoreItem, i) => {
                                return (
                                    <div
                                        className={`score-item ${showMatchWinner(outcome, completionType) ? wonSet(scoreItem, playerType) ? 'winner' : '' : ''}`}
                                        key={`score-item-${i}`}
                                        data-testid={testIdPrefix && `${testIdPrefix}.score-item-${i}`}
                                    >
                                        {playerType === playerTypes.WINNER ? scoreItem.winner ? scoreItem.winner : 0 : scoreItem.loser ? scoreItem.loser : 0}
                                        {(scoreItem.tiebreak != null && scoreItem.tiebreak >= 0) && (
                                            <sup data-testid={testIdPrefix && `${testIdPrefix}.score-item-${i}.tiebreak`}>{playerType === playerTypes.WINNER ? scoreItem.winnerTiebreak : scoreItem.tiebreak}</sup>
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    );
                }

                if (playerType === playerTypes.LOSER && isLeaguesMatch) {
                    return (
                        <span className="outcome-font" data-testid={testIdPrefix && `${testIdPrefix}.outcome`}>{getLeaguesMatchOutcome(completionType)}</span>
                    );
                }

                if (playerType === playerTypes.LOSER && (walkOverValues.includes(outcome) || completionType === 'winnerdidnotstart') && isPendingMatch(playerPostedResult, finalized, isRejected, playerId, players?.winner1?.id, players?.loser1?.id, players?.winner2?.id, players?.loser2?.id)) {
                    return (
                        <span className="outcome-font" data-testid={testIdPrefix && `${testIdPrefix}.outcome`}>{titleCase(outcome) || 'Walkover'}</span>
                    );
                }

                if (playerType === playerTypes.LOSER && ForfeitValues.includes(outcome) && isPendingMatch(playerPostedResult, finalized, isRejected, playerId, players?.winner1?.id, players?.loser1?.id, players?.winner2?.id, players?.loser2?.id)) {
                    return (
                        <span className="outcome-font" data-testid={testIdPrefix && `${testIdPrefix}.outcome`}>Forfeit</span>
                    );
                }
            }
        };

        const getMatchStatus = () => {
            if (playerPostedResult && !finalized) {
                if (isRejected) {
                    return 'Rejected';
                }
                return <div className={`pending-tag d-inline-block`} data-testid={dataTestId && `${dataTestId}.pending-tag`}>Pending</div>;
            }
            if (!finalized && checkIfPlayerInResult(playerId, players)) {
                return <div className={`pending-tag d-inline-block`} data-testid={dataTestId && `${dataTestId}.pending-tag`}>Pending</div>;
            }
            if (outcome === 'completed' || completionType === 'winnercompleted') {
                if (ForfeitValues.includes(outcome) && hasScore) {
                    return 'Forfeit';
                }
                return null; // Standard Card Winner in a regular scenario
            }
            if (outcome === 'incomplete') {
                return 'Incomplete'; // An incompleted match due to weather etc.
            }
            if (completionType === 'tieincomplete') {
                return 'Not Finished'; // An incompleted match due to weather etc.
            }
            if (completionType === 'tiecompleted') {
                return 'Tie'; // A Tie Match
            }
            if (outcome === OutComeTypes.ABANDONED) {
                return AbandonedMatchLabel;
            }
            if (outcome === OutComeTypes.DOUBLEWALKOVER) {
                return DoubleWalkoverLabel;
            }
            if (outcome === OutComeTypes.DEFAULTED) {
                return DefaultedLabel;
            }
            if (outcome === OutComeTypes.WITHDREW) {
                return WithdrewLabel;
            }
            if (retiredValues.includes(outcome) || completionType === 'winnerincomplete') {
                return 'Retired'; // Player Retired due to injury and match completed
            }
            if (walkOverValues.includes(outcome) || completionType === 'winnerdidnotstart') {
                return null; // Player defaulted or withdrew condition
            }
            return null;
        };

        const getLeagueMatchStatus = () => {
            const { RETIRED, POSTPONED } = leagueCompletionTypes;

            if (completionType === POSTPONED) {
                return 'Incomplete';
            }

            if (completionType === RETIRED) {
                return 'Retired';
            }

            return null;
        };

        const getStatusForMatch = () => {
            if (isLeaguesMatch) {
                return getLeagueMatchStatus();
            }
            return getMatchStatus();
        };

        const getDrawTag = (position) => {
            let player; let team;
            const isPlayer = position && position.type && position.type.value === 'player';
            const isTeam = position && position.type && position.type.value === 'team';

            if (position) {
                if (isPlayer) {
                    player = playersDict[position.id];
                    return player?.draws?.[round.draw]?.tag?.value;
                }
                if (isTeam) {
                    team = teamsDict[position.id];
                    return team?.draws?.[round.draw]?.tag?.value;
                }
            }
            return <>&nbsp;</>;
        };

        const renderPlayerHSInfo = (player) => {
            if (currentEvent.playersDict) {
                const playerObj = currentEvent.playersDict[player.id];
                if (playerObj && playerObj.highSchool !== null) {
                    return renderHSInfo(playerObj);
                }
            }
        };

        const getContactObj = (mId) => {
            return (contacts || []).find(({ memberId }) => memberId === mId);
        };

        const isCurrentUserRegistered = (memberId) => {
            return userLoggedIn?.id === memberId;
        };

        const getListTeam = (player1, player2, position, winnerObject, showDateInsteadOfRound, hideDate, teamName, teamId) => {
            const showDecimalsP1 = showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player1.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player1.id === playerId.toString());
            const showDecimalsP2 = player2 != null && (showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player2.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player2.id === playerId.toString()));
            const isPlayer = position && position.type && position.type.value === 'player';
            const isTeam = position && position.type && position.type.value === 'team';
            let player1FromDict = player1; let player2FromDict = player2;

            // Get Players Names from PlayerDictionary
            if (position) {
                if (isPlayer) {
                    player1FromDict = playersDict[position.id] || player1;
                }
                if (isTeam) {
                    const team = teamsDict[position.id];
                    player1FromDict = (team && playersDict[team.players[0]]) || player1;
                    player2FromDict = (team && playersDict[team.players[1]]) || player2;
                    if (parseInt(player1FromDict.id) !== parseInt(player1.id)) {
                        [player1FromDict, player2FromDict] = [player2FromDict, player1FromDict];
                    }
                }
            }
            return (
                <div className="team aic">
                    <div className="flex-column player-details-container col-4">
                        <div className="player-details">
                            {!!player1.clubProfileImages && (
                                <BackgroundImage
                                    baseUrl={'/v1/club/'}
                                    defaultImage={'/img/utr-ball--teal.svg'}
                                    images={player1.clubProfileImages}
                                    imageType={'thumbnail'}
                                    parentStylesClass={'flag-container club-profile-image'}
                                />
                            )}
                            {!player1.clubProfileImages && (
                                <div className="flag-container">
                                    {player1.nationality && (
                                        <Img
                                            src={getFlagUrl(player1.nationality)}
                                            className="flag"
                                            alt={player1.nationality}
                                        />
                                    )}
                                </div>
                            )}
                            <a
                                href={`/profiles/${player1.id}`}
                                className={`flex-column player-name ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                data-testid={dataTestId && `${dataTestId}.desktop.position-${position?.id}.player1-link`}
                            >
                                {titleCase(getPlayerName(player1FromDict.firstName, player1FromDict.lastName, false))}
                            </a>
                            {!!isOfficialHSEvent && renderPlayerHSInfo(player1)}
                        </div>
                        {player2 && (
                            <div className="player-details">
                                {!!player2.clubProfileImages && (
                                    <BackgroundImage
                                        baseUrl={'/v1/club/'}
                                        defaultImage={'/img/utr-ball--teal.svg'}
                                        images={player2.clubProfileImages}
                                        imageType={'thumbnail'}
                                        parentStylesClass={'flag-container club-profile-image'}
                                    />
                                )}
                                {!player2.clubProfileImages && (
                                    <span className="flag-container">
                                        {player2.nationality && (
                                            <Img
                                                src={getFlagUrl(player2.nationality)}
                                                className="flag"
                                                alt={player2.nationality}
                                            />
                                        )}
                                    </span>
                                )}
                                <a
                                    href={`/profiles/${player2.id}`}
                                    className={`flex-column player-name ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                    data-testid={dataTestId && `${dataTestId}.desktop.position-${position?.id}.player2-link`}
                                >
                                    {titleCase(getPlayerName(player2FromDict.firstName, player2FromDict.lastName, false))}
                                </a>
                            </div>
                        )}
                    </div>
                    {!hideDate && !isProfileResults && (
                        <div className="flex-column date-round" data-testid={dataTestId && `${dataTestId}.desktop.position-${position?.id}.date-round`}>
                            {showDateInsteadOfRound ? (customDateString || formatMatchDateWithOffset(date, this.props.timeZoneValue, true)) : round ? round.name : ''}
                        </div>
                    )}
                    <div className={`flex-column utr-container col-${isLeaguesMatch ? '2' : '3'}`}>
                        {showRatings && (
                            <div
                                className={`utr ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                title={getRatingTitle(player1, gameType)}
                            >
                                <Utr player={player1} pbrClass={styles.pbr} isProgressionDraw={isProgressionDraw} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }} sportTypeId={sportTypeId} />
                            </div>
                        )}
                        {player2 && showRatings && (
                            <div
                                className={`utr ${showMatchWinner(outcome, completionType) && winnerObject ? 'winner' : ''}`}
                                title={getRatingTitle(player2, gameType)}
                            >
                                <Utr player={player2} pbrClass={styles.pbr} isProgressionDraw={isProgressionDraw} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP2 }} sportTypeId={sportTypeId} />
                            </div>
                        )}
                    </div>
                    {isLeaguesMatch && (
                        <div className={`flex-column col-3`}>
                            <a href={`${config.leaguesAppHost}/teams/${teamId}`} data-testid={dataTestId && `${dataTestId}.desktop.position-${position?.id}.team-link`}>{teamName}</a>
                        </div>
                    )}
                    <div className={`flex-column scores-conatiner col-${isLeaguesMatch ? '2' : '4'}`} data-testid={dataTestId && `${dataTestId}.desktop.position-${position?.id}.scores`}>
                        {winnerObject ? getScores(score, playerTypes.WINNER, dataTestId && `${dataTestId}.desktop.position-${position?.id}.scores`) : getScores(score, playerTypes.LOSER, dataTestId && `${dataTestId}.desktop.position-${position?.id}.scores`)}
                    </div>
                    <div className="flex-column winner-display-conatiner">
                        {winnerObject && showMatchWinner(outcome, completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </div>
            );
        };

        const getCardTeam = (player1, player2, position, isWinner, seed) => {
            const showDecimalsP1 = showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player1.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player1.id === playerId.toString());
            const showDecimalsP2 = player2 != null && (showDecimals || isProProfile || (auth && auth.user && auth.user.claimedPlayer && player2.id === auth.user.claimedPlayer.playerId.toString() && showDecimalForOwn && player2.id === playerId.toString()));
            const isPlayer = position && position.type && position.type.value === 'player';
            const isTeam = position && position.type && position.type.value === 'team';
            const teamName = isWinner && winner?.teamName ? winner?.teamName : loser?.teamName;
            const teamId = isWinner && winner?.teamId ? winner?.teamId : loser?.teamId;
            let player = player1; let player1FromDict = player1; let player2FromDict = player2;

            // Get Players Names from PlayerDictionary
            if (position) {
                if (isPlayer) {
                    player = playersDict[position.id] || player1;
                }
                if (isTeam) {
                    const team = teamsDict[position.id];
                    player1FromDict = (team && playersDict[team.players[0]]) || player1;
                    player2FromDict = (team && playersDict[team.players[1]]) || player2;
                    if (parseInt(player1FromDict.id) !== parseInt(player1.id)) {
                        [player1FromDict, player2FromDict] = [player2FromDict, player1FromDict];
                    }
                }
            }
            return (
                <div className="team">
                    <span className="seed" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.seed`}>
                        {seed}
                    </span>
                    <div className="flex-column player-details-container ml0 align-items-center">
                        {!player2 && (
                            <div className={`player-details ${styles.overflow}`}>
                                {!!player1.clubProfileImages && (
                                    <BackgroundImage
                                        baseUrl={'/v1/club/'}
                                        defaultImage={'/img/utr-ball--teal.svg'}
                                        images={player1.clubProfileImages}
                                        imageType={'thumbnail'}
                                        parentStylesClass={'flag-container club-profile-image'}
                                    />
                                )}
                                {!player1.clubProfileImages && (
                                    <span className="flag-container">
                                        {player1.nationality && (
                                            <Img
                                                src={getFlagUrl(player1.nationality)}
                                                className="flag"
                                                alt={player1.nationality}
                                            />
                                        )}
                                    </span>
                                )}
                                <div className={`d-flex flex-column justify-content-start align-items-start player-name ${styles.name} ${showMatchWinner(outcome, completionType) ? isWinner ? 'winner' : '' : ''}`}>
                                    <Link to={`/profiles/${player1.id}`} className={styles.link} data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-link`}>
                                        <div className="d-flex flex-row align-items-baseline">
                                            <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-name`}>
                                                {titleCase(getPlayerName(player.firstName, player.lastName, true))}
                                            </div>

                                            {showContacts && getContactObj(player1.memberId) && <PhoneInfoPopup {...getContactObj(player1.memberId)} playerId={player1.id} showEditContacts={isCurrentUserRegistered(player1.memberId)} />}
                                            {showRatings && (
                                                <div className="utr-container">
                                                    <Utr pbrClass={styles.pbr} player={player1} isProgressionDraw={isProgressionDraw} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }} sportTypeId={sportTypeId} />
                                                </div>
                                            )}
                                        </div>

                                    </Link>
                                    {isLeaguesMatch && (
                                        <a href={`${config.leaguesAppHost}/teams/${teamId}`} className={styles.teamLink} data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.team-link`}>
                                            {teamName}
                                        </a>
                                    )}
                                    {!!isOfficialHSEvent && <div className="hs-info" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-hs-info`}>{renderPlayerHSInfo(player1)}</div>}
                                </div>
                            </div>
                        )}
                        {player1 && player2 && (
                            <div className={`player-details ${styles.overflow}`}>
                                {!!player1.clubProfileImages && (
                                    <BackgroundImage
                                        baseUrl={'/v1/club/'}
                                        defaultImage={'/img/utr-ball--teal.svg'}
                                        images={player1.clubProfileImages}
                                        imageType={'thumbnail'}
                                        parentStylesClass={'flag-container club-profile-image'}
                                    />
                                )}
                                <div className={`d-flex flex-column justify-content-start align-items-start player-name ${styles.name} ${showMatchWinner(outcome, completionType) && isWinner ? 'winner' : ''}`}>
                                    <Link to={`/profiles/${player1.id}`} className={styles.link} data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-link`}>
                                        <div className="d-flex flex-row aic">
                                            {!player1.clubProfileImages && (
                                                <span className="flag-container">
                                                    {player1.nationality && (
                                                        <Img
                                                            src={getFlagUrl(player1.nationality)}
                                                            className="flag"
                                                            alt={player1.nationality}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                            <div className="d-flex flex-row align-items-baseline">
                                                <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-name`}>
                                                    {titleCase(getPlayerName(player1FromDict.firstName, player1FromDict.lastName, true))}
                                                </div>
                                                {showContacts && getContactObj(player1.memberId) && <PhoneInfoPopup {...getContactObj(player1.memberId)} playerId={player1.id} showEditContacts={isCurrentUserRegistered(player1.memberId)} />}
                                                {showRatings && (
                                                    <div className="utr-container">
                                                        <Utr pbrClass={styles.pbr} player={player1} isProgressionDraw={isProgressionDraw} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP1 }} sportTypeId={sportTypeId} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                    {!!isOfficialHSEvent && <div className="hs-info" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player1-hs-info`}>{renderPlayerHSInfo(player1)}</div>}
                                    <Link to={`/profiles/${player2.id}`} data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player2-link`}>
                                        <div className="d-flex flex-row aic">
                                            {!player2.clubProfileImages && (
                                                <span className="flag-container">
                                                    {player2.nationality && (
                                                        <Img
                                                            src={getFlagUrl(player2.nationality)}
                                                            className="flag"
                                                            alt={player2.nationality}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                            <div className="d-flex flex-row align-items-baseline">
                                                <div className="p0 mb0 name-wrapper show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player2-name`}>
                                                    {titleCase(getPlayerName(player2FromDict.firstName, player2FromDict.lastName, true))}
                                                </div>
                                                {showContacts && getContactObj(player2.memberId) && <PhoneInfoPopup {...getContactObj(player2.memberId)} playerId={player2.id} showEditContacts={isCurrentUserRegistered(player2.memberId)} />}
                                                {showRatings && (
                                                    <div className="utr-container">
                                                        <Utr pbrClass={styles.pbr} player={player2} isProgressionDraw={isProgressionDraw} force={{ ratingType: gameType, utrType, showDecimals: showDecimalsP2 }} sportTypeId={sportTypeId} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                    {isLeaguesMatch && (
                                        <a href={`${config.leaguesAppHost}/teams/${teamId}`} className={styles.teamLink} data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.team-link`}>
                                            {teamName}
                                        </a>

                                    )}
                                    {!!isOfficialHSEvent && <div className="hs-info" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.player2-hs-info`}>{renderPlayerHSInfo(player2)}</div>}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-row aic scores-container" data-testid={dataTestId && `${dataTestId}.mobile.position-${position?.id}.scores`}>
                        {isWinner ? getScores(score, playerTypes.WINNER, dataTestId && `${dataTestId}.mobile.position-${position?.id}.scores`) : getScores(score, playerTypes.LOSER, dataTestId && `${dataTestId}.mobile.position-${position?.id}.scores`)}
                    </div>
                    <div className="d-flex flex-column jcc winner-display-container">
                        {isWinner && showMatchWinner(outcome, completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </div>
            );
        };

        const renderMatchOfficial = id => {
            const { coreUI, drawOfficials } = this.props;
            const foundMatch = drawOfficials?.find(matchFromDraw => matchFromDraw.id === id);
            const foundOfficial = foundMatch?.officials[0];
            if (foundOfficial) {
                const { countries } = coreUI.types.search;
                const countryCode = countries.find(c => c.id === foundOfficial.official.countryId)?.label;
                return `Chair Umpire: ${foundOfficial.official.firstName[0]}. ${foundOfficial.official.lastName} (${countryCode})`;
            }
            return '';
        };

        const closeConfirmPopup = () => {
            this.setState({
                showConfirmPopUp: false,
            });
        };

        const matchDate = moment.utc(date).tz(this.props.timeZoneValue);
        const formattedDate = matchDate.format('MMM D');
        const time = matchDate.format('LT');
        const matchRound = round?.name || '';
        const isEligibleMatch = eligibleResults?.includes(id);
        const isVerifiedMatch = this.props.showVerified && sourceType === 'sanctioned';
        const isTimeBasedResult = draw?.isTimeBased;
        const dateTimeLineItems = [
            time,
            formattedDate,
            ...(matchRound ? [matchRound] : []),
        ];

        return (
            <>
                <div className={`utr-card score-card ${!!isOfficialHSEvent && 'hs-event'}`} data-testid={dataTestId}>
                    <div className={`${forceCardView || (force && force.cardView) ? 'd-block' : 'd-block d-md-none'}`}>
                        <div className="card-view">
                            {(!!auth?.feedPreferences?.showPickleballContent) && !!sportTypeId && (
                                <SportLabel sportTypeId={sportTypeId} />
                            )}
                            <div className="header">
                                <div className="match-data">
                                    {showDate && date
                                        ? (
                                            <div className="flex-column date" data-testid={dataTestId && `${dataTestId}.mobile.date`}>
                                                {customDateString || `${formatMatchDateWithOffset(date, this.props.timeZoneValue)}${displayTime ? ` at ${formatMatchTime(date, this.props.timeZoneValue)}` : ''}`}
                                            </div>
                                        ) : (
                                            <div className="flex-column date">&nbsp;</div>
                                        )}
                                    {isTimeBasedResult && (
                                        <>
                                            {showDate && date && (
                                                <div className="flex-column vertical-separator ml8 mr4">&nbsp;</div>
                                            )}
                                            <Img
                                                className="time-based"
                                                src="/img/v4/icon-clock.svg"
                                                title="This match uses timed based scoring"
                                            />
                                        </>
                                    )}
                                    <div className="flex-column match-status" data-testid={dataTestId && `${dataTestId}.mobile.match-status`}>
                                        {getStatusForMatch()}
                                    </div>
                                </div>
                                <div className="player-data">
                                    <div className="draw-tag fs10" data-testid={dataTestId && `${dataTestId}.mobile.draw-tag-1`}>{getDrawTag(position1)}</div>
                                    {wonGame(players, lookUpPlayerId) && (
                                        <>
                                            {getCardTeam(players.winner1, players.winner2, position1, true, position1Seed)}
                                            {players.winner2 && <hr className="mt0 mb0 mr16" />}
                                            {getCardTeam(players.loser1, players.loser2, position2, false, position2Seed)}
                                        </>
                                    )}
                                    {!wonGame(players, lookUpPlayerId) && (
                                        <>
                                            {getCardTeam(players.loser1, players.loser2, position1, false, position1Seed)}
                                            {players.loser2 && <hr className="mt0 mb0 mr16" />}
                                            {getCardTeam(players.winner1, players.winner2, position2, true, position2Seed)}
                                        </>
                                    )}
                                    <div className="draw-tag fs10" data-testid={dataTestId && `${dataTestId}.mobile.draw-tag-2`}>{getDrawTag(position2)}</div>
                                    {isLeaguesMatch && isProfileOverviewResult && eventName && eventId && (
                                        <div className={styles.sessionName}>
                                            <a href={`${config.leaguesAppHost}/leagues/session/${eventId}`} className={styles.sessionLink} data-testid={dataTestId && `${dataTestId}.mobile.session-link`}>
                                                {` ${eventName}`}
                                            </a>
                                        </div>

                                    )}
                                </div>
                            </div>
                            <hr className={`divider`} />
                            {isEventScore
                                ? (
                                    <div className="footer align-items-center">
                                        <div>
                                            {roundNumber && renderRoundLabel()}{locationDisplay ? <span data-testid={dataTestId && `${dataTestId}.mobile.location`}> • {locationDisplay}</span> : ''}
                                            {showOfficial && (
                                                <div data-testid={dataTestId && `${dataTestId}.mobile.match-official`}> {renderMatchOfficial(matchId)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className={`footer ${showAcceptOrReject ? 'padding' : ''}`}>
                                        {!showAcceptOrReject && (
                                            <>
                                                <div className="flex-column round-match-type" data-testid={dataTestId && `${dataTestId}.mobile.round-label`}>
                                                    {renderNonEventRoundLabel()}
                                                </div>
                                                <div className="flex-column icon-container mt4">
                                                    {isEligibleMatch && (
                                                        <Img src="/img/utr-ball--cdd5d9.svg" title={`Used for ${ratingTypes.tennis} Calculation`} className="icon utr-ball cursor-pointer" />
                                                    )}
                                                    {isVerifiedMatch && (
                                                        <Img src={'/img/v2/icons/icon-verified-blue.svg'} className="icon cursor-pointer" title="This result is from a verified event" />
                                                    )}
                                                </div>
                                            </>
                                        )}
                                        {showAcceptOrReject && actions && actions.accept && actions.accept.allowed && (
                                            <button
                                                type="button"
                                                className="btn btn-sm mr8"
                                                data-testid={dataTestId && `${dataTestId}.mobile.confirm-btn`}
                                                onClick={() => {
                                                    this.props.acceptOrRejectScore(id, 'accept', this.props);
                                                }}
                                            >
                                                Confirm
                                            </button>
                                        )}
                                        {showAcceptOrReject && actions && actions.reject && actions.reject.allowed && (
                                            <button
                                                type="button"
                                                className="btn btn-sm mr-auto"
                                                data-testid={dataTestId && `${dataTestId}.mobile.deny-btn`}
                                                onClick={() => {
                                                    this.props.acceptOrRejectScore(id, 'reject', this.props);
                                                }}
                                            >
                                                Deny
                                            </button>
                                        )}
                                        {menuOptions.length > 0 && (
                                            <div className="options-container">
                                                {this.getCurrentStatus() === 'Pending' && (
                                                    <span className={`${styles.scoreUpdateRequested} mr8`} data-testid={dataTestId && `${dataTestId}.mobile.score-update-requested`}>Score update requested</span>
                                                )}
                                                <PopOverMenu
                                                    horizontalEllipsis={false}
                                                    menuItems={menuOptions}
                                                    onSelected={this.getCurrentStatus() === 'Pending' ? null : this.onSelected}
                                                    anchorClass={`pt4 ${this.getCurrentStatus() === 'Pending' ? styles.disabledMenu : ''}`}
                                                    disabled={this.getCurrentStatus() === 'Pending'}
                                                    data-testid={dataTestId && `${dataTestId}.mobile.menu`}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className={`${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                        <div className={`list-view ${isProfileResults && 'd-flex flex-column'}`}>
                            {!!sportTypeId && (
                                <SportLabel sportTypeId={sportTypeId} />
                            )}
                            {isProfileResults && (
                                <div className="header">
                                    <div className="row">
                                        <div className="d-flex col justify-content-between align-items-start flex-wrap w-100">
                                            <div className={styles.headerLeftContent}>
                                                <span className={styles.dateTimeText} data-testid={dataTestId && `${dataTestId}.desktop.date`}>
                                                    {`${dateTimeLineItems.join(' | ')}${isTimeBasedResult ? ' |' : ''} `}
                                                </span>
                                                <div className={`${styles.iconContainer}`}>
                                                    {isTimeBasedResult && (
                                                        <Img src={'/img/v4/icon-clock.svg'} className={`${styles.icon} cursor-pointer ml0`} title="This match uses timed based scoring" />
                                                    )}
                                                    {isVerifiedMatch && (
                                                        <Img src={'/img/v2/icons/icon-verified-blue.svg'} className={`${styles.icon} cursor-pointer`} title="This result is from a verified event" />
                                                    )}
                                                    {isEligibleMatch && (
                                                        <Img src="/img/utr-ball--cdd5d9.svg" title={`Used for ${ratingTypes.tennis} Calculation`} className={`${styles.icon} cursor-pointer`} />
                                                    )}
                                                </div>
                                            </div>
                                            <div className={styles.headerRightContent}>
                                                {!wonGame(players, lookUpPlayerId) && (
                                                    <div className="flex-row" data-testid={dataTestId && `${dataTestId}.desktop.match-status`}>{getStatusForMatch()}</div>
                                                )}
                                                {wonGame(players, lookUpPlayerId) && (
                                                    <div className="flex-row" data-testid={dataTestId && `${dataTestId}.desktop.match-status`}>{getStatusForMatch()}</div>
                                                )}
                                                {desktopMenuOptions.length > 0 && (
                                                    <div className={styles.scoreUpdateSection}>
                                                        {this.getCurrentStatus() === 'Pending' && (
                                                            <span className={styles.scoreUpdateRequested} data-testid={dataTestId && `${dataTestId}.desktop.score-update-requested`}>
                                                                Score update requested
                                                            </span>
                                                        )}
                                                        <PopOverMenu
                                                            horizontalEllipsis={false}
                                                            menuItems={desktopMenuOptions}
                                                            onSelected={this.getCurrentStatus() === 'Pending' ? null : this.onSelected}
                                                            anchorClass={`pop-over-menu-nchor ${this.getCurrentStatus() === 'Pending' ? styles.disabledMenu : ''}`}
                                                            disabled={this.getCurrentStatus() === 'Pending'}
                                                            data-testid={dataTestId && `${dataTestId}.desktop.menu`}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="data">
                                <div className="draw-tag fs10" data-testid={dataTestId && `${dataTestId}.desktop.draw-tag-1`}>{getDrawTag(position1)}</div>
                                {wonGame(players, lookUpPlayerId) && (
                                    <>
                                        {getListTeam(players.winner1, players.winner2, position1, true, true, !showDate, winner?.teamName, winner?.teamId)}
                                        {getListTeam(players.loser1, players.loser2, position2, false, false, !showDate, loser?.teamName, loser?.teamId)}
                                    </>
                                )}
                                {!wonGame(players, lookUpPlayerId) && (
                                    <>
                                        {getListTeam(players.loser1, players.loser2, position1, false, true, !showDate, loser?.teamName, loser?.teamId)}
                                        {getListTeam(players.winner1, players.winner2, position2, true, false, !showDate, winner?.teamName, loser?.teamId)}
                                    </>
                                )}
                                <div className="draw-tag fs10" data-testid={dataTestId && `${dataTestId}.desktop.draw-tag-2`}>{getDrawTag(position2)}</div>
                            </div>
                            {!isProfileResults && (
                                <div className="match-status-container">
                                    {getStatusForMatch() && (getStatusForMatch() !== 'Retired' || !wonGame(players, lookUpPlayerId)) && (
                                        <div className="flex-row">
                                            <div className="content-center" data-testid={dataTestId && `${dataTestId}.desktop.match-status`}>
                                                {getStatusForMatch()}
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex-row">
                                        <div className="content-center">
                                            <div className="icon-container">
                                                {eligibleResults && (eligibleResults.findIndex(k => k === id) !== -1) && (
                                                    <Img src="/img/utr-ball--cdd5d9.svg" className="icon utr-ball cursor-pointer" title={`Used for ${ratingTypes.tennis} Calculation`} />
                                                )}
                                                {(this.props.showVerified && sourceType && sourceType === 'sanctioned') && (
                                                    <Img src={'/img/v2/icons/icon-verified-blue.svg'} className="icon cursor-pointer" title="This result is from a verified event" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {getStatusForMatch() && (getStatusForMatch() === 'Retired' && wonGame(players, lookUpPlayerId)) && (
                                        <div className="flex-row">
                                            <div className="content-center" data-testid={dataTestId && `${dataTestId}.desktop.match-status`}>
                                                {getStatusForMatch()}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {!isProfileResults && (
                                <div className="options-container align-self-center">
                                    {desktopMenuOptions.length > 0 && (
                                        <PopOverMenu
                                            horizontalEllipsis={false}
                                            menuItems={desktopMenuOptions}
                                            onSelected={this.getCurrentStatus() === 'Pending' ? null : this.onSelected}
                                            anchorClass={`pop-over-menu-nchor ${this.getCurrentStatus() === 'Pending' ? styles.disabledMenu : ''}`}
                                            disabled={this.getCurrentStatus() === 'Pending'}
                                            data-testid={dataTestId && `${dataTestId}.desktop.menu`}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {this.state.showDeletePopUp && (
                    <Popup
                        className="popup-md"
                        data-testid="modal.score-card.delete"
                        onCloseClick={() => {
                            this.setState({
                                showDeletePopUp: false,
                            });
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                        }}
                    >
                        <div className="popup-section p24 pt0 pb0">
                            <h5 className="text-dark mb0" data-testid="modal.score-card.delete.title">
                                Delete score
                            </h5>
                        </div>
                        <div className="popup-section p24 text-dark">
                            <p data-testid="modal.score-card.delete.message">
                                {`Are you sure you want to delete this score for ${this.getMatchText(players)} on ${formatMatchDateWithOffset(date, this.props.timeZoneValue, false, true)}. This action cannot be reversed.`}
                            </p>
                            <div className="mt24">
                                <div className="row">
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-default btn-default text-uppercase btn-block"
                                            data-testid="modal.score-card.delete.cancel-btn"
                                            onClick={() => {
                                                this.setState({
                                                    showDeletePopUp: false,
                                                });
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-default text-uppercase btn-block"
                                            data-testid="modal.score-card.delete.delete-btn"
                                            onClick={() => {
                                                this.setState({
                                                    showDeletePopUp: false,
                                                });
                                                this.props.deleteUserScore(this.props.id, this.props);
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
                {this.state.showConfirmPopUp && (
                    <Popup
                        className="popup-md"
                        data-testid="modal.score-card.confirm"
                        onCloseClick={closeConfirmPopup}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                        }}
                    >
                        <div className="popup-section p24 pt0 pb0">
                            <h5 className="text-dark mb0" data-testid="modal.score-card.confirm.title">
                                Confirm score
                            </h5>
                        </div>
                        <div className="popup-section p24 text-dark">
                            <p data-testid="modal.score-card.confirm.message">
                                {`You are confirming score ${this.getMatchText(players, score, true)}.`}
                            </p>
                            <div className="mt24">
                                <div className="row">
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-default btn-default text-uppercase btn-block"
                                            data-testid="modal.score-card.confirm.cancel-btn"
                                            onClick={closeConfirmPopup}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-default text-uppercase btn-block"
                                            data-testid="modal.score-card.confirm.ok-btn"
                                            onClick={() => {
                                                closeConfirmPopup();
                                                this.props.acceptOrRejectScore(this.props.id, 'accept', this.props);
                                            }}
                                        >
                                            Ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
                {this.state.showProtestPopUp && (
                    <Popup
                        className="popup-md"
                        data-testid="modal.score-card.protest"
                        onCloseClick={() => {
                            this.setState({
                                showProtestPopUp: false,
                            });
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                        }}
                    >
                        <div className="popup-section p24 pt0 pb0">
                            <h5 className="text-dark mb0" data-testid="modal.score-card.protest.title">
                                Protest score
                            </h5>
                        </div>
                        <div className="popup-section p24 text-dark">
                            <p data-testid="modal.score-card.protest.message">
                                If you believe this match should not count please click <a href={'https://utr.typeform.com/to/v6EvT2cP#mid=xxxxx'} rel="noopener noreferrer" target="_blank" data-testid="modal.score-card.protest.link">here</a>. But if the score is simply incorrect please select the Edit option to correct it.
                            </p>
                        </div>
                    </Popup>
                )}

                {this.state.showIncorrectScorePopUp && (
                    <Popup
                        className={`popup-md ${styles.popupConfig}`}
                        data-testid="modal.score-card.incorrect-score"
                        onCloseClick={() => {
                            this.setState({
                                showIncorrectScorePopUp: false,
                                sourceUrl: '',
                                sourceUrlError: '',
                                isSubmitting: false,
                            });
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                            noHeader: true,
                        }}
                    >
                        <div className={styles.popupContainer}>
                            <p className={styles.popupHeader} data-testid="modal.score-card.incorrect-score.header">
                                {this.getIncorrectScoreMessage().header}
                            </p>
                            <p className={styles.popupDetails} data-testid="modal.score-card.incorrect-score.details">
                                {this.getIncorrectScoreMessage().details}
                            </p>

                            {this.shouldShowSourceUrlInput() && (
                                <div className={styles.inputContainer}>
                                    <input
                                        type="url"
                                        className={`form-control ${styles.inputField} ${this.state.sourceUrlError ? styles.inputError : ''
                                            }`}
                                        placeholder="Paste URL here (e.g., https://example.com)"
                                        value={this.state.sourceUrl}
                                        data-testid="modal.score-card.incorrect-score.source-url-input"
                                        onChange={(e) => {
                                            const url = e.target.value;
                                            this.setState({
                                                sourceUrl: url,
                                                sourceUrlError: this.validateUrl(url),
                                            });
                                        }}
                                        disabled={this.state.isSubmitting}
                                        required
                                    />
                                    {this.state.sourceUrlError && (
                                        <div className={styles.errorMessage} data-testid="modal.score-card.incorrect-score.error-message">
                                            {this.state.sourceUrlError}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className={styles.buttonContainer}>
                                <div className={styles.buttonWrapper}>
                                    <button
                                        type="button"
                                        className={`btn btn-default text-uppercase btn-block ${styles.cancelButton}`}
                                        data-testid="modal.score-card.incorrect-score.cancel-btn"
                                        onClick={() => {
                                            this.setState({
                                                showIncorrectScorePopUp: false,
                                                sourceUrl: '',
                                                sourceUrlError: '',
                                                isSubmitting: false,
                                            });
                                        }}
                                        disabled={this.state.isSubmitting}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className={styles.buttonWrapper}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary text-uppercase btn-block ${styles.submitButton} ${(this.state.isSubmitting || this.isSubmitDisabled())
                                            ? styles.submitButtonDisabled
                                            : ''
                                            }`}
                                        data-testid="modal.score-card.incorrect-score.submit-btn"
                                        onClick={() => {
                                            if (!this.state.isSubmitting && !this.isSubmitDisabled()) {
                                                this.setState({ isSubmitting: true });
                                                this.submitScoreUpdateRequest(ScoreUpdateRequestTypes.INCORRECT_SCORE, this.state.sourceUrl || null);
                                            }
                                        }}
                                        disabled={this.state.isSubmitting || this.isSubmitDisabled()}
                                    >
                                        {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}

                {this.state.showScoreUpdateSuccessPopUp && (
                    <Popup
                        className={`popup-md ${styles.popupConfig}`}
                        data-testid="modal.score-card.success"
                        onCloseClick={() => {
                            this.setState({
                                showScoreUpdateSuccessPopUp: false,
                            });
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                            noHeader: true,
                        }}
                    >
                        <div className={styles.popupContainer}>
                            <p className={styles.popupHeader} data-testid="modal.score-card.success.title">
                                Thanks for letting us know!
                            </p>
                            <p className={styles.popupDetails} data-testid="modal.score-card.success.message">
                                We&rsquo;re working to resolve the issue. Check back in 48 hours.
                            </p>

                            <div className={styles.centeredButtonContainer}>
                                <button
                                    type="button"
                                    className={`btn btn-primary text-uppercase ${styles.closeButton}`}
                                    data-testid="modal.score-card.success.close-btn"
                                    onClick={() => {
                                        this.setState({
                                            showScoreUpdateSuccessPopUp: false,
                                        });
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Popup>
                )}
            </>
        );
    }
}

ScoreCard.defaultProps = {
    timeZoneValue: 'UTC',
    showVerified: true,
    showDate: true,
    dataImportId: null,
    dataImportTypeId: null,
    'data-testid': null,
};

function mapDispatchToProps(dispatch) {
    return {
        setPlayerPostedMatch: (data) => dispatch(postScoreActions.setPlayerPostedMatch(data)),
        resendInvites: (resultId) => dispatch(postScoreActions.resendInvites(resultId)),
        deleteUserScore: (resultId, result) => dispatch(postScoreActions.deleteUserScore(resultId, result)),
        acceptOrRejectScore: (resultId, acceptOrReject, result) => dispatch(postScoreActions.acceptOrRejectScore(resultId, acceptOrReject, result)),
        setRound: (data) => dispatch(postScoreActions.setRound(data)),
    };
}

function mapStateToProps({ events, coreUI }) {
    const { drawOfficials, currentEvent, contacts } = events;
    return { currentEvent, drawOfficials, coreUI, contacts };
}

export default withRouter(withAuth((connect(mapStateToProps, mapDispatchToProps)(ScoreCard))));
